const Env = require('../env').env

var constants
if (Env == 'prod') {
  constants = require('./constants-prod')
} else {
  constants = require('./constants-dev')
}
module.exports = constants



// WEBPACK FOOTER //
// ./src/base/constants.js